import { put, select, takeLatest } from 'redux-saga/effects'
import { IOption } from '../../../common/common.types'
import { throwApiException } from '../../../features/zollApi/store/zollApi.actions'
import { getSearchStateSelector } from '../selectors'
import { setIsLoading, setFilteredOptions } from '../store/search.actions'
import { SearchConstants } from '../store/search.constants'

export function* setSearchFilteredOptions() {
  try {
    yield put(setIsLoading(true))
    const { searchText, options } = yield select(getSearchStateSelector)
    const tempSearchResult = options.filter((o: IOption) =>
      o.name?.toLowerCase().includes(searchText.toLowerCase().trim())
    )
    yield put(setFilteredOptions([...tempSearchResult]))
  } catch (e: any) {
    yield put(throwApiException(`setSearchFilteredOptions() error: ${e}`))
  }
}

export function* setSearchFilteredOptionsSaga() {
  yield takeLatest([SearchConstants.SET_SEARCH_TEXT], setSearchFilteredOptions)
}
